import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { SubmissionBaseQuestionPreview } from './base-question.component';
import styled from '@xstyled/styled-components';
import { AudioPlayer, MathEnabledTextComponent, styleVariables } from '@lib/common';
import { SubmissionFilePreview } from '../../../../file-storage-components';
import { Space } from 'antd';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var defaultLineHeight = 28; // TODO: Will write a converter later.

var EssayAnswerTextConverter = styled(MathEnabledTextComponent)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  -moz-appearance: textfield-multiline;\n  -webkit-appearance: textarea;\n\n  border: 1px solid gray;\n  height: ", "px;\n  padding: 4px 11px;\n  resize: vertical;\n  width: 100%;\n\n  border-color: #d9d9d9;\n  box-shadow: none;\n  border-radius: 2px;\n\n  color: ", ";\n\n  cursor: not-allowed;\n  opacity: 1;\n  overflow: auto;\n"])), defaultLineHeight * 4, styleVariables.colors.gray13);
var FileContainer = styled(Space)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: auto auto;\n"])));
var AnswerContainer = styled(Space)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var StyledAudioPlayerContainer = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin-top: 16px;\n"])));
export var SubmissionEssayQuestionPreview = function SubmissionEssayQuestionPreview(props) {
  var _answer$value5;

  var isSkipped = props.isSkipped,
      answer = props.answer,
      onShowCarouselModal = props.onShowCarouselModal;

  var renderAnswer = function renderAnswer() {
    var _answer$value;

    if (isSkipped) {
      return /*#__PURE__*/_jsx(EssayAnswerTextConverter, {});
    }

    return /*#__PURE__*/_jsxs(AnswerContainer, {
      direction: "vertical",
      children: [/*#__PURE__*/_jsx(EssayAnswerTextConverter, {
        value: (_answer$value = answer.value) === null || _answer$value === void 0 ? void 0 : _answer$value.text
      }), renderFiles()]
    });
  };

  var renderFiles = function renderFiles() {
    var _answer$value2, _answer$value4;

    var hasOnlyOneQuestion = ((_answer$value2 = answer.value) === null || _answer$value2 === void 0 ? void 0 : _answer$value2.files.length) === 1;

    if (hasOnlyOneQuestion) {
      var _answer$value3;

      var file = (_answer$value3 = answer.value) === null || _answer$value3 === void 0 ? void 0 : _answer$value3.files[0];
      return /*#__PURE__*/_jsx(SubmissionFilePreview, {
        signedUrl: file.url,
        type: file.type,
        onClick: function onClick() {
          return onShowCarouselModal(0);
        }
      });
    }

    return /*#__PURE__*/_jsx(FileContainer, {
      children: (_answer$value4 = answer.value) === null || _answer$value4 === void 0 ? void 0 : _answer$value4.files.map(function (file, index) {
        return /*#__PURE__*/_jsx(SubmissionFilePreview, {
          signedUrl: file.url,
          type: file.type,
          onClick: function onClick() {
            return onShowCarouselModal(index);
          }
        }, file.id.toString());
      })
    });
  };

  return /*#__PURE__*/_jsxs(SubmissionBaseQuestionPreview, _objectSpread(_objectSpread({}, props), {}, {
    isSkipped: isSkipped,
    isEssayQuestion: true,
    children: [renderAnswer(), ((_answer$value5 = answer.value) === null || _answer$value5 === void 0 ? void 0 : _answer$value5.audioFile) && /*#__PURE__*/_jsx(StyledAudioPlayerContainer, {
      children: /*#__PURE__*/_jsx(AudioPlayer, {
        source: answer.value.audioFile.url
      })
    })]
  }));
};